export default "__VITE_ASSET__rz63fMoB__"